import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { faFolder, faFolderOpen } from '@fortawesome/pro-regular-svg-icons';

import { Button } from 'components/ui/button';

class Group extends React.Component {
  static propTypes = {
    group: PropTypes.shape({
      memberCount: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
    selected: PropTypes.bool,
    onDeselect: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired
  }

  handleClick = () => {
    if (this.props.selected) {
      this.props.onDeselect(this.props.group);
    } else {
      this.props.onSelect(this.props.group);
    }
  }

  render() {
    const badgeClassName = classNames('badge badge-muted', {
      'badge-secondary ': !this.props.selected,
      'badge-primary': this.props.selected,
    });

    return (
      <Button
        className="w-100 justify-content-start"
        icon={this.props.selected ? faFolderOpen : faFolder}
        variant="ghost"
        onClick={this.handleClick}
      >
        <span className="flex-grow-1 text-start">
          {this.props.group.name}
        </span>

        <span className={badgeClassName}>
          {this.props.group.memberCount}
        </span>
      </Button>
    );
  }
}

export default Group;
